import {
  FEED_PREVIEW_IMAGE_ORIENTATION,
  FEED_PREVIEW_IMAGE_TYPE,
  fieldTypes
} from '@constants/constant';
import { Fields } from '@modules/dynamic-form-builder/model/formBuilderInterface';

export const PORTFOLIO_TYPE_CONSTS = {
  PORTFOLIO_TYPE: {
    MUSIC: 'MUSIC',
    PODCAST: 'PODCAST',
    VIDEO: 'VIDEO',
    CUSTOM: 'CUSTOM',
    MUSIC_ALBUM: 'MUSIC ALBUM',
    PODCAST_SERIES: 'PODCAST SERIES',
    VIDEO_SERIES: 'VIDEO SERIES',
    COLLECTION: 'COLLECTION'
  },
  PORTFOLIO_TYPE_ARRAY: [
    'MUSIC',
    'PODCAST',
    'VIDEO',
    'CUSTOM',
  ],
  TYPE_VALUE: {
    ALBUM: 'ALBUM'
  },
  PORTFOLIO_STATUS: {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    DRAFT: 'DRAFT'
  },
  PORTFOLIO_TYPE_OPTIONS: [
    { value: 'MUSIC', label: 'Music' },
    { value: 'PODCAST', label: 'Podcast' },
    { value: 'VIDEO', label: 'Video' },
    { value: 'CUSTOM', label: 'Custom' }
  ],
  PORTFOLIO_MASTER_CHILD_TYPE: {
    MUSIC: 'Song',
    PODCAST: 'Podcast',
    VIDEO: 'Episode',
    CUSTOM: 'Item',
  },
  PORTFOLIO_MASTER_CHILD_TYPE_MULTIPLE: {
    MUSIC: 'Songs',
    PODCAST: 'Podcasts',
    VIDEO: 'Episodes',
    CUSTOM: 'Items',
  },
  ADD_EDIT_ROUTE_PATH: {
    MUSIC: 'add-edit-album-portfolio',
    PODCAST: 'add-edit-podcast-portfolio',
    VIDEO: 'add-edit-video-portfolio',
    CUSTOM: 'add-edit-collection-portfolio',
  },
  ADD_PORTFOLIO_TYPE: 'Add Portfolio',
  EDIT_PORTFOLIO_TYPE: 'Edit Portfolio',
  ADD_THUMBNAIL: 'Add Portfolio Image',
  PORTFOLIO_TYPE_LABEL: 'Portfolio Type',
  SELECT_A_TYPE: 'Select a Type',
  PORTFOLIO_TYPE_REQUIRED: 'Portfolio Type is required',
  PORTFOLIO_TITLE_LABEL: 'Portfolio Title to Display on Profile Page',
  WRITE_ITEM_TITLE: 'Write Portfolio Title',
  PORTFOLIO_TITLE_REQUIRED: 'Portfolio Title is required',
  PORTFOLIO_DESCRIPTION_LABEL: 'Portfolio Description (Optional)',
  WRITE_DESCRIPTION_OF_ITEM: 'Write a Description of your Portfolio',
  PORTFOLIO_DESCRIPTION_REQUIRED: 'Portfolio Description is required',
  THUMBNAIL_REQUIRED: 'Thumbnail is required',
  MAX_TITLE_CHARACTERS_ALLOWED: 'Maximum 50 characters allowed',
  MAX_DESCRIPTION_CHARACTERS_ALLOWED: 'Maximum 100 characters allowed',
  PORTFOLIO_SAVED_SUCCESS: 'Portfolio saved successfully',
  AUDIO_FILE: 'Audio File',
  FREE_PREVIEW_DURATION: 'Free Preview Duration',
  VIDEO_FILE: 'Video File',
  VIEW_NOW: 'VIEW NOW',
  VIDEO_COVER_IMAGE_INFO: 'If you are using Direct Sales below, the system will let you choose a Video Cover Image from the uploaded video.'
};

export const addEditPortfolioTypeFields = (isEditMode: boolean = false) => {
  const fields: Fields = {
    sections: [
      {
        title: '',
        fields: [
          {
            type: fieldTypes.BANNER_IMAGE,
            name: 'thumbnail',
            placeholder: '',
            class: 'col-12',
            bannerOrientationPortrait: FEED_PREVIEW_IMAGE_ORIENTATION.LANDSCAPE,
            bannerImageType: FEED_PREVIEW_IMAGE_TYPE.TYPE_2,
            bannerImageType2Title: PORTFOLIO_TYPE_CONSTS.ADD_THUMBNAIL,
            cropperOptions: {
              cropperMinWidth: 800,
              cropperMinHeight: 400,
              cropperStaticWidth: null,
              cropperStaticHeight: null,
              aspectRatio: 2 / 1,
              maintainAspectRatio: true
            },
            validation: {
              required: {
                message: PORTFOLIO_TYPE_CONSTS.THUMBNAIL_REQUIRED
              }
            }
          },
          {
            type: fieldTypes.SELECT,
            label: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE_LABEL,
            name: 'portfolio_type',
            placeholder: PORTFOLIO_TYPE_CONSTS.SELECT_A_TYPE,
            class: 'col-12',
            options: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE_OPTIONS,
            labelKey: 'label',
            valueKey: 'value',
            disabled: isEditMode,
            validation: {
              required: {
                message: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TYPE_REQUIRED
              }
            }
          },
          {
            type: fieldTypes.TEXT,
            label: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TITLE_LABEL,
            name: 'title',
            placeholder: PORTFOLIO_TYPE_CONSTS.WRITE_ITEM_TITLE,
            class: 'col-12',
            autoComplete: 'off',
            validation: {
              required: {
                message: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_TITLE_REQUIRED
              },
              maxlength: {
                value: 50,
                message: PORTFOLIO_TYPE_CONSTS.MAX_TITLE_CHARACTERS_ALLOWED
              }
            }
          },
          {
            type: fieldTypes.TEXT_AREA,
            label: PORTFOLIO_TYPE_CONSTS.PORTFOLIO_DESCRIPTION_LABEL,
            name: 'description',
            placeholder: PORTFOLIO_TYPE_CONSTS.WRITE_DESCRIPTION_OF_ITEM,
            class: 'col-12 danger-alert-field',
            maxlength: 100,
            validation: {
              maxlength: {
                value: 100,
                message: PORTFOLIO_TYPE_CONSTS.MAX_DESCRIPTION_CHARACTERS_ALLOWED
              }
            }
          }
        ]
      }
    ]
  };
  return fields;
};

